import { apiRequest } from '@/utils/request'

// 获取业务窗口列表
export function getBusinessWindowList(queryParams) {
  return apiRequest({
    url: '/BusinessWindow/GetList',
    method: 'get',
    params: queryParams
  })
}

// 业务窗口查看详情
export function getBusinessWindowById(id) {
  return apiRequest({
    url: 'BusinessWindow/View/' + id,
    method: 'get'
  })
}
